import actionTypes from "../../../../action-types";
import TrialState from "../../../../models/state/trials/trial/TrialState";

export default function makeTrialReducer({
  featureType,
  recordTrialEventActionType
}: {
  featureType: string;
  recordTrialEventActionType: string;
}) {
  return function trialReducer(
    state: TrialState | null = null,
    action: Record<string, any>
  ) {
    switch (action.type) {
      case actionTypes.RECEIVE_PREMIUM_TRIALS:
        return new TrialState(action.payload[featureType]);

      case recordTrialEventActionType:
        return state
          ? state.update("remaining", amount => Math.max(0, amount - 1))
          : state;

      default:
        return state;
    }
  };
}
